import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { hidePopupRule } from '@Lib/slices/uiSlice';
import { getSiteBranding } from '@Apis/settings';
import {
  applySiteBrandingToDocument,
  getCurrentSiteBranding,
  normalizeSiteBranding,
  storeSiteBranding,
} from '@Lib/siteBranding';

const toPublicImageUrl = (value, fallbackDir = 'avatar') => {
  if (!value) return '';
  const rawValue = `${value}`.trim();
  if (!rawValue) return '';
  if (rawValue.startsWith('http://') || rawValue.startsWith('https://') || rawValue.startsWith('/')) {
    return rawValue;
  }
  if (rawValue.startsWith('storage/')) {
    return `/${rawValue}`;
  }
  if (rawValue.includes('/')) {
    return `/storage/${rawValue}`;
  }
  return `/storage/${fallbackDir}/${rawValue}`;
};

function ModalRule() {
  const dispatch = useDispatch();
  const isShowPopupRule = useSelector((state) => state.ui.isShowPopupRule);
  const [isBannerDismissed, setIsBannerDismissed] = useState(false);
  const [siteBranding, setSiteBranding] = useState(() => getCurrentSiteBranding());
  const ruleImageUrl = toPublicImageUrl(
    siteBranding.rule_image_url || process.env.SITE_RULE_IMAGE_URL || '/images/rule-SALEVIPS.png',
  );
  const isForceShowBanner =
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('banner') === '1';
  const isOpen = isShowPopupRule || (isForceShowBanner && !isBannerDismissed);

  useEffect(() => {
    let isMounted = true;

    getSiteBranding()
      .then((branding) => {
        if (!isMounted) return;

        const normalized = normalizeSiteBranding(branding);
        setSiteBranding(normalized);
        storeSiteBranding(normalized);
        applySiteBrandingToDocument(normalized);
      })
      .catch(() => {
        // Giữ fallback hiện tại nếu API tạm thời không phản hồi.
      });

    return () => {
      isMounted = false;
    };
  }, []);
  const handleToggle = () => {
    setIsBannerDismissed(true);
    dispatch(hidePopupRule());
  };

  return (
    <Modal
      centered
      isOpen={isOpen}
      toggle={handleToggle}
      style={{ maxWidth: '1000px' }}
    >
      <img src={ruleImageUrl} alt="Quy định sử dụng" />
    </Modal>
  );
}

ModalRule.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

export default ModalRule;
